import { Component } from '@angular/core';
import { Router } from '@angular/router';

@Component({
  selector: 'app-e404',
  standalone: false,
  templateUrl: './e404.component.html',
  styleUrl: './e404.component.scss'
})
export class E404Component {
  constructor(private router: Router) { }

  onHomePageBtnClick() {
    this.router.navigate(['/books']);
  }
}
